import axios from "axios";
import Store from "./Store";
import {
  set_Load_Download,
  set_Message,
  set_Qr_Loading,
} from "./Orders/OrderActionCreators";
import {
  authUnauthorizedMessage,
  officeAuth,
  setShowCaptcha,
} from "./Login/LoginActionCreators";
import {
  popupMessagesHandler,
  setLoading_MODAL,
} from "./General/generalActionCreators";
import { BASE_URL } from "./axios_Instanse";

export const axiosInstance_modal = axios.create({
  baseURL: BASE_URL(),
});
// window.onbeforeunload = () => {
//   socket.disconnect();
// };
axiosInstance_modal.interceptors.request.use((config) => {
  if (!navigator.onLine) {
    const chanel = new BroadcastChannel("isOnline");
    chanel.postMessage({ msg: "notOnline" });
  }
  //  config.baseURL = localStorage.MULTI_SERVER_URL;
  config.baseURL = BASE_URL();
  config.url += `?timeStamp=${new Date().getTime()}`;
  config.headers["token"] = localStorage.token;
  Store.dispatch(setLoading_MODAL(true));

  return config;
});

axiosInstance_modal.interceptors.response.use(
  (config) => {
    Store.dispatch(setLoading_MODAL(false));
    return config;
  },

  (error) => {
    Store.dispatch(setLoading_MODAL(false));
    Store.dispatch(set_Qr_Loading(false));
    switch (error.response.status) {
      case 401:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "error",
          })
        );
        // closeSocket();
        setTimeout(() => {
          localStorage.clear();
          window.location.pathname = "/";
          Store.dispatch(officeAuth(false));
        }, 2000);
        break;

      case 400:
        if (error.response.data.type !== "application/json") {
          Store.dispatch(
            set_Load_Download({
              all: false,
              single: false,
            })
          );
          Store.dispatch(set_Message(error.response.data));
          Store.dispatch(authUnauthorizedMessage(error.response.data));
          Store.dispatch(
            popupMessagesHandler({
              mode: true,
              message: error.response.data,
              color: "info",
            })
          );
        } else {
          Store.dispatch(
            set_Load_Download({
              all: false,
              single: false,
            })
          );
          Store.dispatch(
            popupMessagesHandler({
              mode: true,
              message: "فایل یافت نشد",
              color: "info",
            })
          );
        }
        break;
      case 402:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(setShowCaptcha(true));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "info",
          })
        );

        break;
      case 403:
        Store.dispatch(authUnauthorizedMessage(error.response.data));

        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message: error.response.data,
            color: "info",
          })
        );
        break;
      case 404:
        Store.dispatch(authUnauthorizedMessage(error.response.data));
        Store.dispatch(
          popupMessagesHandler({
            mode: true,
            message:
              typeof error.response.data === "object"
                ? error.response.statusText
                : error.response.data,
            color: "info",
          })
        );
        Store.dispatch(
          set_Load_Download({
            all: false,
            single: false,
          })
        );
        break;

      default:
        break;
    }

    return Promise.reject(error);
  }
);
